import React, { useState } from 'react';

import update from 'react-addons-update';
import { Modal } from 'react-bootstrap';
import phones from 'telephone-stuff';

var validation = {
    locationPhone: phones.validate
};

const LocationCreate = props => {
    const { createModal, toggleCreateModal, save, locations } = props
    const [newLocation, setNewLocation] = useState({
        locationName: '',
        locationDescription: '',
        locationContact: '',
        locationAddress: '',
        locationPhone: ''
    })

    const handleChange = (event) => {
        var updates = {};
        updates[event.target.name] = {$set: event.target.value};
        setNewLocation(update(newLocation, updates))
    }

    var phoneVal = newLocation.locationPhone;
    var valid = {
        locationPhone: phones.validate(phones.parse(phoneVal))
    };

    const isDuplicate = locations.some(location => {
        return location.locationName.trim().toLowerCase() === newLocation.locationName.trim().toLowerCase()
    })
    
    return (
        <Modal animation={false} bsSize="lg" show={createModal} onHide={toggleCreateModal}>
            <Modal.Header>
                <Modal.Title>Create New Location</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label>Location Name</label>
                <input autoFocus className="form-control" name="locationName" value={newLocation.locationName} onChange={handleChange} placeholder="Required"/>

                <div style={{margin: '2rem 0'}}/>

                <label>Address</label>
                <input className="form-control" name="locationAddress" value={newLocation.locationAddress} onChange={handleChange}/>

                <div style={{margin: '2rem 0'}}/>

                <div className="row">
                    <div className="col-md-6">
                        <label>Contact</label>
                        <input className="form-control" name="locationContact" value={newLocation.locationContact} onChange={handleChange}/>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Phone</label>
                            <input className="form-control" name="locationPhone" value={newLocation.locationPhone} onChange={handleChange}/>
                        </div>
                    </div>
                </div>

                <div style={{margin: '2rem 0'}}/>

                <label>Location Description</label>
                <textarea className="form-control" name="locationDescription" value={newLocation.locationDescription} onChange={handleChange}></textarea>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-default" onClick={toggleCreateModal}>Cancel</button>
                {isDuplicate ? <span>{' '}This location name is already in use</span> : <button className="btn btn-primary" onClick={save.bind(null, newLocation)}><i className="fa fa-save"/>
                        {' '}Save
                    </button>}
            </Modal.Footer>
        </Modal>
    );
}

export default LocationCreate;
